/* eslint-disable */

import React, {useEffect, useState, Component}  from 'react'
 // eslint-disable-next-line
import ReactDOM from 'react-dom'
import Cleave from 'cleave.js/react';
import config from '../../../../services/config';
import axios from 'axios';
import '../../../../css/parcelamento.css';

import status1 from './status1.png';
import status2 from './status2.png';
import status5 from './status5.png';

//import BoletoService from '../../../../services/boleto-service'
import error from '../autorizacaoGuias/images/archive.png';
import { render } from '@testing-library/react';
import { findAllInRenderedTree } from 'react-dom/test-utils';

var status = "";


class Cgif extends Component{
    
    render(
       
    ){
        var x;
        
        if(this.props.status!= 'ok'){
            var x = 'visible';
        }else{
            var x = 'hidden';
        }

        if(this.props.status === 'ERROR' || this.props.status === 'ERRO'){
            var x = 'hidden';
        }
        var estilo ={
            visibility:x
        } 
 
        return(
            <span><p align="center"><div style={estilo} className="fa fa-spinner fa-3x fa-spin divgif2" align="center"></div></p></span>
        )
    }
    
}

// Classe para Tela de Checkout  

class Ccheckout extends Component{
    constructor (props){
        super(props);
    }
   
    
    render(){
      /*const [loading,setLoading] = useState(false);
        const renderLoading = () =>{
            if(loading){
                return  <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
            }
        }*/ 
    //    const  [habilitado,setHabilitado]= useState("disabled");
        //const url = "http://172.22.0.145/hml/14/portaldocliente/arqs/restTermoParcelamento.php?action=termo&nome=" + this.props.nome + "&parcelas=" + this.props.parcelas + "&percentual=" + this.props.percentual; 
        const url = "https://portaldocliente.unimedvs.com.br/arqs/restTermoParcelamento.php?action=termo&nome=" + this.props.nome + "&parcelas=" + this.props.parcelas + "&percentual=" + this.props.percentual; 
        var estilo = {
           visibility: this.props.visibilidade
               }
               var estilo2 = {
                visibility: 'hidden'
                    }       
               let x = true;
        function cancelar(){
           // alert('cancelando');
            document.getElementById('checkout').style.visibility = 'hidden';
        }    
        function habilita(){
           if(document.getElementById("aceite").checked == true){ 
              document.getElementById("btn_pagar").disabled = false;
              
           }else{
               document.getElementById("btn_pagar").disabled = true;
           }
        }
        
        function validaDadosCartao(){
                var erros=''; 
                var mes = '';
                var ano = '';
                var anoAtual = '';
                var mesAtual ='';
                // validação de preenchimento
                if( document.getElementById("cc_numero").value==''){
                erros += 'Numero de cartão não informado\n';
                }
                if( document.getElementById("cc_nome").value==''){
                erros += 'Nome do Titular do Cartão não informado\n';
                }
                if( document.getElementById("cc_snome").value.length == 0){
                    erros += 'Sobrenome do Titular do Cartão não informado\n';
                }
                
                // validações da data
                if(document.getElementById("cc_validade").value=='' ){
                        erros +='Validade do cartão não informada\n';  
                }    
                if(document.getElementById("cc_cvv").value=='' ){
                    erros +='CVV não informado\n';  
            }  
                if(document.getElementById("cc_validade").value.length < 4 && document.getElementById("cc_validade").value.length >0){
                        erros +='Formato da Validade incorreto(MMAA)\n';  
                }
                  mes = parseInt(document.getElementById("cc_validade").value.substr(0,2));
                  ano = parseInt(document.getElementById("cc_validade").value.substr(2,2));
                    
                if(mes<1 || mes>12){
                       erros +='Mes inválido\n';  
                }
                var data = new Date();
                anoAtual = parseInt(data.getFullYear().toString().substr(2,2));
                mesAtual = parseInt(data.getMonth().toString());
                
                if(ano < anoAtual){
                    erros +='Ano inválido inválido\n';  
                }
               if((ano == anoAtual)  && (mes < mesAtual)){
                  erros +='Mes informado é anterior à atual\n';  
                }
                  
                    
                               
                //validação de tipo 
                if(erros.length > 0){
                    return 'Foram encontrados os erros abaixo, favor corrigi-los\n '+ erros ;
                }else{
                    return true;
                }
        }
       
        
        async function  pagar(){

            if(validaDadosCartao() == true){
                if(document.getElementById("aceite").checked == true){ 
                    document.getElementById("btn_pagar").disabled = true;

                    let cc_numero = document.getElementById("cc_numero").value;
                    let cc_nome = document.getElementById("cc_nome").value;
                    let cc_snome = document.getElementById("cc_snome").value;
                    let cc_cvv = document.getElementById("cc_cvv").value;
                    let cc_validade= document.getElementById("cc_validade").value;
                    let mes =  cc_validade.substr(0,2);
                    let ano = cc_validade.substr(2,2);
                    let seqneg = document.getElementById("seqped").innerHTML;
                    let pagamento = {};
                    let vCheckout = {"negociacao":seqneg.trim(),
                                    "dadoscartao":{"numero": cc_numero,
                                                "cvv":cc_cvv,
                                                "nome":cc_nome,
                                                "sobrenome":cc_snome,
                                                "mes_vencto": mes,
                                                "ano_vencto":ano}
                                }	
                    
                    //Manda dados para pagamento
                    vCheckout = JSON.stringify(vCheckout);
                    document.getElementById("gifcheckout").style.visibility = "visible";
                    let pag = await axios
                    //.post('http://172.22.0.22:9056/rest/WsEntradaNeg',vCheckout)                    
                    .post('https://portaldocliente.unimedvs.com.br/arqs/ajNegociacoesPg.php',vCheckout)
                    .catch(error => {
                    // fazer tratativa dos erros
                    alert(error)   

                    }) 
   
                    if(pag.data.status=='ok'){
                        alert('Negociação finalizada com sucesso, aguardando efetivação da entrada');
                        document.getElementById("checkout").style.visibility = 'hidden';
                        document.getElementById("gifcheckout").style.visibility = 'hidden';
                        document.getElementById("btn_pagar").disabled = false;
                        console.log('status de pag = '+ pag.data.status);
                       
                      //this.props.setStatusNeg(pag.data.status);
                      this.props.setStatusNeg('5');
                      
                    }else{
                        console.log(vCheckout);
                        console.log(JSON.stringify(vCheckout));
                        alert('Erro no Checkout : ' + pag.data.descricao);						  
                        document.getElementById("gifcheckout").style.visibility = 'hidden';
                        console.log('status de pag  erro = '+ pag.data.status)
                        console.log('pag',pag);
                    }
                    
                    
           
                    
                }else{
                    alert('É necessário confirmar a leitura dos termos \npara conclusão da negociação');
                } 
                            
                //console.log('vCheckout',vCheckout);  
                }else{
                  alert(validaDadosCartao());
                }
            }
        return( 
              
             <div id="checkout" className="divcheckout" style={estilo}> 
              <span><p align="center"><div id="gifcheckout" style={estilo2} className="fa fa-spinner fa-3x fa-spin divgif3" align="center"></div></p></span>
                 
                 <table align="center" className="tabela_checkout" valign="center">
                    <tr>
                       <td>
                         <table bgcolor="white">
                            <tr><td colspan="3" className="titulo_checkout"> <span><p><b className="titulo_checkout">UNIMED VALE DOS SINOS - CENTRAL DE PAGAMENTOS</b></p></span> </td></tr>
                            <tr><td colspan="3"> <span>Preencha com os dados do cartão de crédito</span> </td></tr>
                            <tr><td colspan="3" className="tdesquerda"><span><input type="text" className="inputfield" placeholder=" Número do cartão" id="cc_numero" /></span></td></tr>
                            <tr><td colspan="3" className="tdesquerda"><span><input type="text" className="inputfield" placeholder=" Nome impresso no cartão" id="cc_nome"/></span> </td></tr>
					        <tr><td colspan="3" className="tdesquerda"><span><input type="text" className="inputfield" placeholder=" Sobrenome impresso no cartão" id="cc_snome"/></span> </td></tr>
                            <tr>
				                 <td className="tdesquerda"><input type="text" placeholder=" Validade (MMAA)" id="cc_validade" maxlength="4" className="inputfield"/></td>
					             <td>&nbsp;</td>
					             <td><input type="text" placeholder=" CVV" id="cc_cvv" className="inputfield"  maxlength="3"/></td></tr>
		  			       <tr><td>&nbsp;</td></tr>
                           <tr><td colspan="3"><span><input type="checkbox" id="aceite"  onClick={()=>{habilita()}}
                           
                           />Declaro que li e aceito os termos do contrato disponível no <a  className="link" href={url} target="_blank">link</a></span></td></tr>
					
                    </table>
                   </td>
                   <td className="meio">&nbsp;</td>
                   <td>
			           <table className="tabela_pedido">
				         <tr><td><p align="center"><b>Resumo do Pedido</b></p></td></tr>
				         <tr><td><hr/></td></tr>
        <tr><td className="tdesquerda"><b>Negociação Número: </b><span id="seqped" value={this.props.sequencial}> {this.props.sequencial}</span></td></tr>
        <tr><td className="tdesquerda"><b>Data Pedido: </b><span id="datPed"> {parseData(this.props.dataPedido)}</span></td></tr>
        <tr><td className="tdesquerda"><b>Valor Negociação:  </b><span id="valTotal"> {parseReal(this.props.valorTotal)}</span></td></tr>
        <tr><td className="tdesquerda"><b>Parcelas: </b><span id="numParcelas"> {this.props.parcelas}</span></td></tr>
				         <tr><td className="tdesquerda"><b>Valor Entrada:</b><span id="vlrEntrada">{parseReal(this.props.valorEntrada)} </span></td></tr>
        <tr><td className="tdesquerda"><b>Valor Parcela:</b><span id="vlrParcela"> {parseReal(this.props.valorParcelas)}</span></td></tr>
				         <tr><td><hr/></td></tr>
				         <tr><td><button clasName="botaopagar" id="btn_pagar" onClick={()=>{pagar()}}>Pagar</button></td></tr>
				</table>
			 </td>
                 </tr>  
                 </table>
                 
            </div>
        )
    }

}

// Função  para tratar status
 function parseStatus(status){
    var rStatus = "";
    switch(status){
        case '1': 
           rStatus = "Aguardando Assinatura";
        break;
        case '2': 
           rStatus = "Aguardando Entrada";
        break;
        case '3': 
           rStatus = "Aguardando Parcelas";
        break;
        case '4': 
           rStatus = "Cancelado";
        break;
        case '5': 
           rStatus = "Finalizado";
        break;
    }
    return rStatus;
}
// função para formato dinheiro
function parseReal(valor){
    var numero = valor.toLocaleString('pt-BR');
     //console.log(numero);
    var real = 'R$ '  + numero.toString();
    return real;
}

// função para extrair data do timestamp
 function parseData (data){
    if(data !='- - T00:00:00	'){
    var ano = data.substr(0,4);
    var mes = data.substr(5,2);
    var dia = data.substr(8,2);
    var rdata = dia +'/' + mes + '/' + ano;
    
    }else{
        rdata = "";
    }
    return rdata;
}

class SequencialLink extends Component{
    handleClick = (props) => {
     
       render(
     
          <Ccheckout 
             visibilidade="visible" 
             sequencial={this.props.sequencial}
             dataPedido={this.props.dataPedido}
             valorTotal={this.props.valorTotal}
             parcelas= {this.props.parcelas}
             valorEntrada={this.props.valorEntrada}
             valorParcelas={this.props.valorParcelas}
             setStatusNeg = {this.props.setStatusNeg}
             nome = {this.props.nome}
             percentual = {this.props.percentual}
             />
       )
     }    
    render(){
        if(this.props.status=="1"){
            return(<span onClick={this.handleClick} className="link">{this.props.sequencial}</span> )
        }else{
            return(<span >{this.props.sequencial}</span> )
        }
        
    }
}
// Classe que retorna Negociações Ativas
class CNegociacoes extends Component{
   
   
    render(){ 
       
        function exibeOculta(id){
                 if(document.getElementById(id).style.display=='none'){
                    document.getElementById(id).style.display= '';
                 }else{
                    document.getElementById(id).style.display= 'none';
                 }
        }          
        function icone(status){
            var retorno = "";
            
            switch(status){
                  case '1': 
                     retorno = "status icone_assinatura fa fa-file-text";
                  break;
                  case '2': 
                     retorno = "status icone_entrada fa fa-file-text";
                  break;
                  case '3': 
                     retorno = "status icone_parcela fa fa-file-text";
                  break;
                  case '4': 
                     retorno = "status icone_cancelado fa fa-file-text";
                  break;
                  case '5': 
                     retorno = "status icone_finalizado fa fa-file-text";
                  break;			  
            }
            return retorno;
        }
        function getImage(id){            
            var retorno = "";
            switch(id){
                case  '1':
                  retorno = status1;
                break;
                case  '2':
                  retorno = status2;
                break;
                case  '5':
                  retorno = status5;   
                break;
            }
           return retorno;
        }
        
       if(this.props.status == 'ok'){   
           console.log(this.props.negociacoes);     
            return (
                    <div >
                        <h3 className="txt-laranja">Negociações Ativas </h3>
                        
                        <table>
                        <thead>
                        <tr>
                            <th>Status</th>
                            <th>Sequencial</th>
                            <th>Data Pedido</th>
                            <th>Data Assinatura</th>
                            <th>Forma de Pagamento</th>
                            <th>Status</th>
                            <th>Parcelas</th>
                            <th>Valor Entrada</th>
                            <th>Valor Parcelas</th>
                            <th>Operador</th>
                            </tr>    
                        </thead>
                        <tbody>
                        {this.props.negociacoes.map((neg,index) => { 
                              return(
                               <>   
                              <tr key={index}>
                                    
                                   <td><i className={icone(neg.status)} id="iconStatus" onClick={ ()=>{exibeOculta(neg.sequencial)}}/></td>
                                   <td><SequencialLink 
                                            sequencial={neg.sequencial} 
                                            dataPedido = {neg.data_pedido}
                                            valorTotal = {neg.total_negociado}
                                            parcelas = {neg.parcelas}
                                            valorEntrada = {neg.valor_entrada}
                                            valorParcelas = {neg.valor_parcelas}
                                            status={neg.status} 
                                            setStatusNeg = {this.props.setStatusNeg}
                                            nome = {this.props.nome}
                                            percentual = {neg.perc_entrada}
                                        
                                            
                                            /></td>
                                   <td>{parseData(neg.data_pedido)}</td>
                                   <td>{parseData(neg.data_assinatura)}</td>
                                   <td>Cartão de Crédito</td>
                                   <td>{parseStatus(neg.status)}</td>
                                   <td>{neg.parcelas}</td>
                                   <td>{parseReal(neg.valor_entrada)}</td>
                                   <td>{parseReal(neg.valor_parcelas)}</td>
                                   <td>{neg.operador}</td>
                                   </tr>
                                   
                              <tr style={{display:'none'}}  id={neg.sequencial}><td colSpan={10} id="tdativas"><img src={getImage(neg.status)}/></td></tr>
                                </>
                                                               
                              )}
                          )}  
                         
                        </tbody>
                        </table>
                    </div> 
                )
       }else{
        return (  <div><h3 className="txt-laranja">Negociações Ativas</h3> 
                  <p><center>Não há Registro de Negociações Ativas</center></p>
                  </div>)
      }  
    }
}





export default ()=>{
  
    const [formaPag,SetFormaPag] = useState([]);
    const [cpf, setCpf] = useState("")
    const [errors, setErrors] = useState ([])
    const [retNegociados,setRetNegociados] = useState([]);
    const [retVencidos,setRetVencidos] = useState([]);
    const [temStatus,setTemStatus] = useState(false);
    const [dadosCliente,setDadosCliente] = useState(false);
    const [statusNeg,setStatusNeg] = useState("");
    const [statusVenc,setStatusVenc] = useState("");
    const [statusCheckout,setstatusCheckout] = useState("hidden");
    const [gif,setGif] = useState(true);   
    const [teste,setTeste] = useState('disabled'); 
    const [verGif,setVerGif]= useState('visibility:hidden');
    const [seqNeg,setSeqNeg] = useState('');
    const [nomeCli,setNomeCli] = useState('');
    const [percEntrada,setPercEntrada] = useState('');
    useEffect(() => {
        window.parent.postMessage('change', window.location.origin)
      });
    
    const validateForm = () => {
        const errors = []
        if(cpf.length === 0){
            errors.push({field: 'cpf',message: 'Preencha seu CPF'})
        }
        else{
            if(cpf.length !== 11 ){
                errors.push({field:"cpf",message:"Verifique seu CPF"})
            }
        }
        setErrors(errors)
        return errors.length
    }
    
   
    
     
 
    let getNegociados = async()=>{     

       
       // busca negociações ativas
        //setLoading(true);
       let negociados = await axios
                        .get('https://portaldocliente.unimedvs.com.br/arqs/ajNegociacoes.php?cpf=' + cpf)                
                        //.get('http://172.22.0.145/hml/14/portaldocliente/arqs/ajNegociacoes.php?cpf=' + cpf) 
                        .catch(error => {
                          // fazer tratativa dos erros
                         if(error = 'Error: Network Error'){
                             alert('Erro: Problemas de conexão com a rede ou internet');
                         }else{
                             alert('Erro ->' + error);   
                         }
                        })  
            console.log('Negociacoes Abaixo');    
            //console.log(negociados.data.negociacoes[0].sequencial);
            console.log(negociados.data);
            if(negociados.data.status !='ERRO'){
                    setNomeCli(negociados.data.dadoscliente.nome);
                    console.log('NR negociação')
                    console.log(seqNeg.toString().padStart(10,"0"));
                    
                    if(verificaSequencialValido(negociados.data.negociacoes,seqNeg.toString().padStart(10,"0"))== false){
                    alert('A Negociação Informada Não existe para este CPF');   
                    setTemStatus(false);
                    // ocultar gif
                    }

                    //console.log(negociados.data.negociacoes);
                    setRetNegociados(negociados.data.negociacoes); 
                    //console.log('ret negociados na funcao',retNegociados)  
                    setStatusNeg(negociados.data.status);
                    //setLoading(false);
        }else{
            alert('Não foram identificadas negociações para o cliente');
            // ocultar gif    
        }     
                
        }     
    // Click para buscar Negociações    
    function verificaSequencialValido(seqobj, seq){
    var i=0;
        console.log(seqobj);
      for(;seqobj[i];){
        if(seqobj[i].sequencial.includes(seq)){
            return true;
            break;
        }
       i++; 
    }
      return false;  
      
       /*seqobj.map((neg,index) => { 
            console.log('neg sequencial => ' + neg.sequencial);
            console.log('neg seq => ' + seq);
            if( neg.sequencial == seq){
                return true;
            }
        })
        return false */
    }
    function handleClick(e) {
        //setGif('visible')        
        e.preventDefault();
        setCpf(cpf);
        setSeqNeg(seqNeg);
       
       // setSeqNeg(seqNeg)
        setVerGif('visible');
        getNegociados();
        setVerGif('hidden');
        setTemStatus(true);
        console.log('testando retnegociados',retNegociados);
       // console.log('tem sequencial?', verificaSequencialValido(retNegociados,seqNeg))
        
      }
 
   
    if(temStatus==false){
        
     return(
        <section className='consulta-copart txt8 lh-1 '>
        <h2 className="txt-laranja">Parcelamento de boletos</h2>
       
        <h3 className="txt-verde">Informe os campos abaixo</h3>
        <div className="box-passos">
         
            <div className="linha-form--small">
                <span>CPF/CNPJ <span className="txt-vermelho">*</span></span>
               <Cleave   maxlength="14" placeholder="Somente Números" type={'ontouchstart' in document.documentElement ? "tel" : "text"} maxleght="14" options={{numericOnly: true}} onChange={e=>setCpf(e.target.rawValue)} />
               
               <span>Negociação <span className="txt-vermelho">*</span></span>
               <input type="text" placeholder="Somente números" id="seqNeg" onChange={e=>setSeqNeg(e.target.value)}></input>
               <button className="btn" id="buscar" onClick={handleClick}>Buscar</button>
            </div>		
        </div>
    </section>
     ) // fim return
     }else{
       
     return(<section id="t">      
               <Cgif visibilidade={verGif} status={statusNeg}/> 
               <CNegociacoes nome={nomeCli} negociacoes={retNegociados} status={statusNeg} setStatusNeg ={setStatusNeg} onClick={handleClick}/>           
                 
             
            </section>
            );
        
     }
    
     }